<template>
  <div
    class="pb8 training-model"
  >
    <!-- evalReportType 0前后侧都无报告 1 前侧报告完成 2前后侧都完成 -->
    <!-- showSkillLevel 测评完成前不显示能力级别(0-关闭,1-开启) -->
    <!-- 机构自建的能力模型有标准及能力级别 -->
    <skill-detail
      class="mt20 training_model-detail"
      :evaluation-detail="trainingSkill"
      :loading="loading"
      :scene="2"
      :fields="fields"
    />
  </div>
</template>

<script>
import skillDetail from './skillDetail';
import trainingRadarMixin from '../mixins/trainingRadar';

export default {
  components: {
    skillDetail
  },
  mixins: [trainingRadarMixin],
  props: {
    modelId: String,
    evaluationList: {
      type: Array,
      default: () => []
    }
  }
};
</script>
